import { combineReducers } from "redux"
import piano from "./piano"
import offer from "./offer"
import distributors from "./distributor"
import customize from "./customize"

export default combineReducers({ piano, offer, distributors, customize })
